module.exports = __webpack_public_path__ + "static/img/icon_hitem1.c232bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem1.png
// module id = ifrI
// module chunks = 21